import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { StoreView } from '@app/modules/common/views/store/store.view';
import { AnalyticService, NotifyService } from '@app/services';
import { TypesForm } from '@forms/time-off-v3/components';
import { iconList } from '@time-off-v3/meta/icon-meta';

@Component({
    templateUrl: './types-store.template.html',
    styleUrls: ['./types-store.style.scss'],
})
export class TypesStoreView extends StoreView {
    @ViewChild('timeOffTypesForm') timeOffTypesForm: TypesForm;
    timeOffType: TimeOffType;
    iconList: string[] = iconList;
    isLoading = false;

    constructor(
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute,
        private analyticService: AnalyticService
    ) {
        super();
        this.timeOffType = new TimeOffType();
    }

    onSave(): void {
        this.timeOffTypesForm.submit();

        if (!this.timeOffTypesForm.valid) {
            return;
        }

        this.isLoading = true;

        this.timeOffType
            .save()
            .then(() => {
                this.isLoading = false;
                this.analyticService.trackEvent(AnalyticEvents.TimeOffTypesAndPoliciesCreatingPolicyType);
                this.notify.success('time-off-v3.timeOffTypeHasBeenCreated');
                this.router.navigate(['/time-off/v3/types-and-policies'], { relativeTo: this.route });
            })
            .catch((err) => {
                this.notify.error(err.message);
                this.isLoading = false;
            });
    }

    onCancel(): void {
        this.router.navigate(['/time-off/v3/types-and-policies'], { relativeTo: this.route });
    }
}
